import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import cn from "classnames";
import CallToActionGroup from "@/components/site-builder/CallToActionGroup";
import TextField from "@/components/site-builder/TextField";
import { TextAlignment } from "@/constants/content";
import { type AccordionBlock as AccordionBlockShape } from "../types";
import s from "./AccordionBlock.module.scss";

export interface AccordionBlockProps {
  block: AccordionBlockShape;
  defaultExpanded: boolean;
}

export function AccordionBlock(props: AccordionBlockProps) {
  const { block, defaultExpanded } = props;
  const { title, body, buttons } = block;

  const buttonsShown = buttons.some(({ shown }) => shown);

  return (
    <Accordion defaultExpanded={defaultExpanded} className={s.block}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={cn(s.title, {
          [s.centerAligned]: title.alignment === TextAlignment.Center,
        })}
      >
        <TextField field={title} type="header-h4" />
      </AccordionSummary>
      <AccordionDetails className={s.body}>
        <TextField field={body} type="text-regular" />
      </AccordionDetails>
      {buttonsShown && (
        <AccordionActions className={s.footer}>
          <CallToActionGroup buttons={buttons} />
        </AccordionActions>
      )}
    </Accordion>
  );
}
